import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect, useSelector } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import user1 from "../../../assets/images/users/user-tmp.png"

const ProfileMenu = props => {
  const currentUser = useSelector(state => state.Login.user)
  const [menu, setMenu] = useState(false)

  function fullName() {
    return `${currentUser.first_name}  ${currentUser.last_name}`
  }

  return (
    <React.Fragment>
      {currentUser && (
        <Dropdown
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item "
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={user1}
              alt="Header Avatar"
            />
            <span className="d-none d-sm-inline-block ms-2 me-1">
              {fullName()}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <Link to="/profile">
              <DropdownItem className="dropdown-item">
                <i className="bx bx-user font-size-16 align-middle me-2" />
                {props.t("Profile")}
              </DropdownItem>
            </Link>
            {currentUser && currentUser.is_admin && (
              <Link to="/user-setting">
                <DropdownItem className="dropdown-item">
                  <i className="fas fa-users font-size-12 align-middle me-2" />
                  {props.t("User settings")}
                </DropdownItem>
              </Link>
            )}
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span> {props.t("Logout")} </span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      )}
      {!currentUser && (
        <Link to="/login" className="text-white">
          <span className="d-inline-block ms-2 me-1">Login</span>
        </Link>
      )}
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  return {}
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
